import { IGif } from '@giphy/js-types'
import React, { useContext } from 'react'
import ModalContext from 'shared/components/context/modal'
import styled from 'styled-components'

const Container = styled.div`
    cursor: pointer;
    display: block;
    font-size: 17px;
    font-weight: bold;
    display: flex;
    align-items: center;
    padding: 6px 10px;
    .ss-plus {
        margin-right: 19px;
        padding-top: 6px;
        font-size: 23px;
    }
`
const GifDetailAddToCollection = ({ gif }: { gif: IGif }) => {
    const { openGifEditPanel } = useContext(ModalContext)
    return (
        <Container onClick={() => openGifEditPanel(gif, 'Collections')}>
            <div className="ss-plus" />
            Add to Collection
        </Container>
    )
}
export default GifDetailAddToCollection
